import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import TableRowCount from "../../../../../components/pagination/rows";
import Pagination from "../../../../../components/pagination";
import {
  SetMaxPage,
  SetActivePage,
} from "../../../../../services/redux/slices/diagnostics/clinic/clinicMenus";

const Footer = () => {
  const dispatch = useDispatch();
  const { maxPage: authMaxPage } = useSelector(({ auth }) => auth);
  const {
    isLoading,
    activePage,
    filtered = [],
    activeView,
    maxPage,
  } = useSelector(({ clinicMenus }) => clinicMenus);
  const totalPages = Math.max(
    1,
    Math.ceil(
      filtered.filter(({ itemType }) =>
        activeView === "meds" ? itemType === "meds" : itemType !== "meds",
      ).length / maxPage,
    ) || 1,
  );

  useEffect(() => {
    if (authMaxPage) {
      dispatch(SetMaxPage(authMaxPage));
    }
  }, [dispatch, authMaxPage]);

  const handlePageChange = (action) => {
    const newPage =
      typeof action === "number" ? action : activePage + (action ? 1 : -1);
    if (newPage >= 1 && newPage <= totalPages) {
      dispatch(SetActivePage(newPage));
    }
  };

  return (
    <div className="mb-auto d-flex justify-content-between align-items-center px-4">
      <TableRowCount disablePageSelect={false} />
      <Pagination
        isLoading={isLoading}
        total={totalPages}
        page={activePage}
        setPage={handlePageChange}
      />
    </div>
  );
};

export default Footer;
